"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  BROWSER_KEY: true,
  onError: true,
  setContext: true,
  RetryLink: true,
  getDataFromTree: true,
  InMemoryCache: true,
  MockedProvider: true,
  gql: true,
  GraphQLError: true
};
exports.BROWSER_KEY = void 0;
Object.defineProperty(exports, "GraphQLError", {
  enumerable: true,
  get: function () {
    return _graphql.GraphQLError;
  }
});
Object.defineProperty(exports, "InMemoryCache", {
  enumerable: true,
  get: function () {
    return _cache.InMemoryCache;
  }
});
Object.defineProperty(exports, "MockedProvider", {
  enumerable: true,
  get: function () {
    return _testing.MockedProvider;
  }
});
Object.defineProperty(exports, "RetryLink", {
  enumerable: true,
  get: function () {
    return _retry.RetryLink;
  }
});
Object.defineProperty(exports, "getDataFromTree", {
  enumerable: true,
  get: function () {
    return _ssr.getDataFromTree;
  }
});
Object.defineProperty(exports, "gql", {
  enumerable: true,
  get: function () {
    return _graphqlTag.default;
  }
});
Object.defineProperty(exports, "onError", {
  enumerable: true,
  get: function () {
    return _error.onError;
  }
});
Object.defineProperty(exports, "setContext", {
  enumerable: true,
  get: function () {
    return _context.setContext;
  }
});
var _client = require("@apollo/client");
Object.keys(_client).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _client[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _client[key];
    }
  });
});
var _components = require("@apollo/client/react/components");
Object.keys(_components).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _components[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _components[key];
    }
  });
});
var _hoc = require("@apollo/client/react/hoc");
Object.keys(_hoc).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _hoc[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _hoc[key];
    }
  });
});
var _error = require("@apollo/client/link/error");
var _context = require("@apollo/client/link/context");
var _retry = require("@apollo/client/link/retry");
var _ssr = require("@apollo/client/react/ssr");
var _cache = require("@apollo/client/cache");
var _testing = require("@apollo/client/testing");
var _typePolicies = require("./type-policies");
Object.keys(_typePolicies).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _typePolicies[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _typePolicies[key];
    }
  });
});
var _invalidationPolicies = require("./invalidation-policies");
Object.keys(_invalidationPolicies).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _invalidationPolicies[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _invalidationPolicies[key];
    }
  });
});
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _graphql = require("graphql");
// follows the same logic as the app-configs' browser key:
// https://github.com/NerdWallet/nwjs-app-config/blob/39f3662d5ec7701d31b1dde176ea53ecf1a2647a/src/browser-key.js
const id = process.env.BROWSER_APP_CONFIG_ID || process.env.CLIENT_ID || '';
const BROWSER_KEY = exports.BROWSER_KEY = `__APOLLO_STATE--${id.toUpperCase()}__`;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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